<template>
  <div class="app-wrapper">
   
   

<!-- <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="IsNotice"  :title="gets('$提示')" id="getNoticeDialog"  width="30%">
            <div class="page_content" id="page_content" style="display: initial;text-align:center;">


 

<div style="height:50px;font-size:20px"><span style="color:red;font-size:40px">{{PurNotice}}</span> <span style="padding-left:2px;font-size:20px">{{gets('$个需要处理的询价需求')}}</span>
 <span style="">
                   <el-button  @click="GOPUR()"  class="GOPURclass" type="primary" icon="el-icon-edit">{{gets('$前往')}}</el-button></span></div>
<div style="height:50px;font-size:20px">
  <span style="color:red;font-size:40px">{{OrderNotice}}</span> <span style="padding-left:2px;font-size:20px;" :style="{'padding-right':window.$.cookie('LanguagesTag')=='EN'?'95px':'0px'}">{{gets('$个需要处理的采购任务')}}</span>


 <el-button  @click="GONotice()" style="margin-left: 10px;" type="primary" icon="el-icon-edit">{{gets('$前往')}}</el-button></div>

            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="IsNotice=false">{{gets('$确定')}}</el-button>

            </div>
        </el-dialog> -->





 <div >
              <!--导航栏-->
    <div :style="{width:Iscollapse?'70px !important' :'15% !important','z-index':999,}" :class="UserContext.UserType==1?'sidebar-container':'sidebar-container sidebar-container2'">
      <div>
        <img src="../assets/img/MKD-logo.png" v-if="!Iscollapse" alt="" style="    width: 100%;margin: auto;padding: 20px;">
        <img src="../assets/img/smallLogo.png" v-else alt="" style="width: 70%;margin-left: 15%;margin-top: 15%;margin-bottom:20px;">
      </div>
      <el-scrollbar wrapClass="scrollbar-wrapper" class="indexScroll">
        <!-- <div class="User">Iscollapse
        </div> -->
         <!-- default-active="/" -->
         <!-- :unique-opened="UserContext.UserType==1?true :false" -->
        <el-menu  class="el-menu-vertical-demo" mode="vertical"  :class="UserContext.UserType==1?'customerHorizontalMenu' :'horizontalMenu'"   :show-timeout="6000" :hide-timeout="6000" :collapse="Iscollapse" style="height: 100% !important;" @open="handleOpen" @close="handleClose">
          <!--
                          <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
                            <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
                            <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{generateTitle(item.children[0].meta.title)}}</span>
                          </el-me nu-item>
                      -->
          <!-- <el-submenu index="首页" >
           
             <template slot="title">
               <img src="../assets/img/Dashboard.png" alt="" style="width:16px;margin-right:14px;margin-left:4px;">
               <span>{{gets('$首页')}}</span>
              </template>
              
          </el-submenu> -->
          <!-- <div style="display: flex;
          align-items: center;
          justify-content: space-between;" class="addSidebar"> -->
          <el-menu-item index="/" style="" default-active :class="UserContext.UserType==1?'CustomSidebar' :'CustomSidebar2'"  @click="openDashboard()">
            <!-- <template slot="title"> -->
              <!-- <div> -->
                <img src="../assets/img/Dashboard.png" alt="" style="width:18px;margin-right:14px;margin-left:4px;">
                <span class="navAddText" slot="title">{{gets('$首页')}}</span>
              <!-- </div> -->
               
             
              <!-- </template> -->
          </el-menu-item>
            <el-menu-item v-if="UserContext.UserType==1" default-active :class="UserContext.UserType==1?'CustomSidebar' :'CustomSidebar2'"  @click="toMall()">
            <!-- <template slot="title"> -->
              <!-- <div> -->
                <img src="../assets/img/Mall.png" alt="" style="width:18px;margin-right:14px;margin-left:4px;">
                <span class="navAddText" slot="title">{{gets('$商城')}}</span>
              <!-- </div> -->
               
             
              <!-- </template> -->
          </el-menu-item>
           <!-- <i class="el-icon-arrow-right" style="font-size: 19px !important;
              color: #fff !important;
              margin-right: 30px !important;" v-if="!Iscollapse"></i>
          </div> -->
          <!-- v-if="!Iscollapse" -->
          <el-menu-item style="margin-top:30px;" :class="UserContext.UserType==1?'CustomSidebar' :'CustomSidebar2'" v-if="!Iscollapse">
            <template slot="title">
              <span class="navAddText" v-if="language=='EN'" slot="title" style="font-weight: lighter;font-family: Helvetica light;letter-spacing:0.5px;">MANAGEMENT</span>
              <span class="navAddText" v-else slot="title" style="font-weight: lighter;font-family: Helvetica light;letter-spacing:0.5px;">管理</span>
            </template>
          </el-menu-item>
          <el-submenu  :index="i.name" v-for="i in d.navs"  v-if="IsShowNavs(i.twoNavs)&&i.name!='推广管理'&&i.name!='财务管理'&&i.name!='推广'&&i.name!='Affiliate'&&i.name!='Affiliation'&&i.name!='Financial'"   >
            <template slot="title" v-show ="!i.name!='推广'&&i.name!='Affiliate'&&i.name!='Affiliation'&&i.name!='Account '">
              <img src="../assets/img/Shop.png" alt="" style="width:18px;margin-right:14px;margin-left:4px;" v-if="i.name=='店铺管理'||i.name=='Shop Setting'" >
              <img src="../assets/img/Mall.png" alt="" style="width:18px;margin-right:14px;margin-left:4px;" v-if="i.name=='商城'||i.name=='Mall'" >
              <img src="../assets/img/Order.png" alt="" style="width:16px;margin-right:14px;margin-left:4px;" v-if="i.name=='订单'||i.name=='订单管理'||i.name=='Order'" >
              <img src="../assets/img/Purchasing.png" alt="" style="width:18px;margin-right:14px;" v-if="i.name=='采购管理'||i.name=='Purchasing'" >
              <img src="../assets/img/Warehouse.png" alt="" style="width:18px;margin-right:14px;margin-left: 2px;" v-if="i.name=='仓库'||i.name=='仓库管理'||i.name=='Warehouse'||i.name=='Warehouse '" >
              <img src="../assets/img/Financial.png" alt="" style="width:16px;margin-right:14px;margin-left: 2px;" v-if="i.name=='财务管理'||i.name=='Financial'" >
              <img src="../assets/img/Customer.png" alt="" style="width:19px;margin-right:14px;margin-left:1px;" v-if="i.name=='账户管理'||i.name=='客户管理'||i.name=='Customer '||i.name=='Account '" >  
              <img src="../assets/img/Affiliation.png" alt="" style="width:17px;margin-right:14px;margin-left:2px;" v-if="i.name=='推广管理'||i.name=='推广'||i.name=='Affiliation'||i.name=='Affiliate'" >              
              <img src="../assets/img/setting.png" alt="" style="width:16px;margin-right:14px;margin-left:4px;" v-if="i.name=='系统管理'|| i.name=='System'" > 
              <img src="../assets/img/Operation.png" alt="" style="width:16px;margin-right:14px;margin-left:4px;margin-left: 2px;" v-if="i.name=='物流管理'||i.name=='Operation'" >  
              <img src="../assets/img/channel.png" alt="" style="width:16px;margin-right:14px;margin-left:4px;" v-if="i.name=='渠道管理'||i.name=='Channel'" >          
                              <!-- <span v-if="UserContext.UserType==1&&i.name=='商城'">{{i.name}}</span> -->
                              <span>{{i.name}}</span>
           
            </template>
            <el-menu-item   v-if="IsRight(c.moduleID)" v-for="c in i.twoNavs" :tag="i.name+'/'+c.name" :index="i.name+'/'+c.name"  @click="openNav(i,c)" >{{c.name}}</el-menu-item>

          </el-submenu>
          <el-menu-item style="margin-top:30px;"  :class="UserContext.UserType==1?'CustomSidebar' :'CustomSidebar2'" v-if="!Iscollapse">
            <template slot="title">
              <span class="navAddText" v-if="language=='EN'" slot="title" style="font-weight: lighter;font-family: Helvetica light;letter-spacing:0.5px;">PERSONAL</span>
              <span class="navAddText" v-else slot="title" style="font-weight: lighter;font-family: Helvetica light;letter-spacing:0.5px;">个人</span>
              </template>
          </el-menu-item>

          <el-submenu :index="i.name"  v-for="i in d.navs"  v-if="IsShowNavs(i.twoNavs)&&i.name=='推广管理'||i.name=='财务管理'||i.name=='推广'||i.name=='Affiliate'||i.name=='Affiliation'||i.name=='Financial'">
            <template slot="title" >
                    <img src="../assets/img/Customer.png" alt="" style="width:19px;margin-right:14px;margin-left:1px;" v-if="i.name=='账户管理'||i.name=='客户管理'||i.name=='Customer '||i.name=='Account '" >  
                    <img src="../assets/img/Affiliation.png" alt="" style="width:17px;margin-right:14px;margin-left:2px;" v-if="i.name=='推广管理'||i.name=='推广'||i.name=='Affiliation'||i.name=='Affiliate'" >              
                     <img src="../assets/img/Financial.png" alt="" style="width:16px;margin-right:14px;margin-left: 2px;" v-if="i.name=='财务管理'||i.name=='Financial'" >    
                    <span >{{i.name}}</span>
            
            </template>
            <el-menu-item    v-if="IsRight(c.moduleID)" v-for="c in i.twoNavs" :tag="i.name+'/'+c.name" :index="i.name+'/'+c.name"  @click="openNav(i,c)" >{{c.name}}</el-menu-item>

          </el-submenu>
          
          <div style="position:absolute; cursor: pointer;left:16%;margin-top:35%;" v-if="!Iscollapse&&UserContext.UserType==1">
            <img src="../assets/img/service.png" alt="" class="serviceImg" @click="toMyQusetion()"> 
            <div class="servicePositionText" v-if="language=='EN'" >{{gets('$帮助')}}</div>
             <div class="servicePositionText" v-else style="right:45%">{{gets('$帮助')}}</div>
          </div>
          <div style="position:absolute;cursor:pointer;bottom:0;left:8%;" v-if="Iscollapse&&UserContext.UserType==1">
          
              <img src="../assets/img/smallServiec.png" alt="" @click="toMyQusetion()"  style="width:70%;margin-bottom:17%;">
            
          </div>
          <!-- <a href="#" target="_blank" style="font-size: 15px; width:80px;font-size:14px;padding-left: 10px; color: red; line-height: 50px;">操作指引</a>-->
        </el-menu>
          
      </el-scrollbar>
     
<!--底部版权 -->
<!-- <div id="footer" :style="{'background-color':UserContext.UserType==1?'rgb(56, 121, 237)':'#222'}" >CopyRight@copy2012 </div> -->
    </div>
    <!-- <div class="drawer-bg" ></div>
                      <sidebar class="sidebar-container"></sidebar>
                          -->
<!--导航栏结束-->

    <div class="main-container" :style="{'margin-left':Iscollapse?'70px !important':'15% !important','background-color': '#F3F7F9','padding-top':'70px'}">
      <!-- <navbar></navbar>
                      <tags-view></tags-view>
                      <app-main></app-main>
                -->

      <div>
        <div :style="{'width':Iscollapse?'97%':'85%','background':'#fff','height':'70px','display':'flex','justify-content': 'space-between','position':'fixed','top':'0','z-index':'5',}">
          <div v-if="UserContext.UserType==1" style="height: 100%;display: flex;align-items: center;margin-left:40px;cursor:pointer;" @click="isC"><img src="../../src/assets/img/nav_menu.png" alt="" style="width:23px;"> </div>
          <div v-else style="height: 100%;display: flex;align-items: center;margin-left:40px;cursor:pointer;" @click="isC"><img src="../../src/assets/img/nav_menu2.png" alt="" style="width:23px;"> </div>
          <div>
            <div style="height: 100%;display: flex;align-items: center;">
               
                <!-- 新闻公告图标动态 -->
                <span @click="showNotice()" style="display:inline-block;width:20px;">
                  <img class="el-icon-bell" src="../assets/img/nav_bellicon.png" style="width:20px;cursor:pointer;">
                  <div class="notify"> 
                    <span class="heartbit"></span> <span class="point"></span> 
                  </div>
                  <transition name="el-zoom-in-top">
                  <div class="news-list" v-show="showNoticeData" :class="UserContext.UserType==1?'news-list2 animated' :'news-list3 animated'">
                     
        
      
                      <ul>
                        <li style="padding: 5px 0px;border-bottom: 1px solid rgba(120, 130, 140, 0.13);cursor:pointer;" v-for="o in SearchSys_New" :key="o.ID">
                          <div style="display:flex;align-items:center;"  @click="ToNew(o.ID)">
                            <i class="el-icon-news" style="font-size:27px;margin:0px 20px;color: rgb(56, 121, 237);"></i>
                            <div style="text-align:left;">
                              <div style="line-height:25px;">{{o.Title}}</div>
                              <div style="line-height:20px;font-size:12px;color:#67757c;">{{o.OperatorTime}}</div>
                            </div>
                          </div>
                        </li>

                      </ul>
                    </div>
                    </transition>
                </span>
                <!-- 顶部导航栏语言切换 -->
                <lang-select class="set-language" style="color:#000;cursor:pointer;margin:0px 30px;"></lang-select>
                <!-- 个人信息入口 -->
                <el-dropdown trigger="click" class='international' @command="UserCommand">
                      <div>
                        <span class="el-dropdown-link" style="height: 100%;display: flex;align-items: center;">
                            <span  style="margin-left:40px;width: max-content;cursor:pointer;"  v-if="UserContext"> 
                             
                                <div>
                                  <div style="font-weight:bold;">{{UserContext.LastName}}&nbsp;{{UserContext.FirstName}}</div>
                                  <div style="font-size:16px;">{{UserContext.Code}}</div>
                                </div>
                              
                              
                              
                            </span>
                            <!-- <img :src="require('@/assets/img/user.png')" style="width:20px; height:20px;cursor:pointer;margin-right: 20px;"   /> -->
                            <div class="userBG">
                                {{NameFirst}}
                            </div>
                        </span>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="User">{{gets('$个人信息')}}  </el-dropdown-item>
                        <el-dropdown-item command="Exit">{{gets('$注销')}}</el-dropdown-item>
                      </el-dropdown-menu>
                </el-dropdown>
                 <!--上边语言-->
                <!-- <el-menu class="navbar" mode="horizontal"  v-if="UserContext" :style="{'background-color':UserContext.UserType==1?'#3879ED':'#283038'}"  style=" width: 100%; display: flex;text-color:#fff;  position: fixed; z-index:1000">
                  <div class="hamburger-container" style="line-height: 50px; ">
                    <span style="margin-left:20px;float:  left;"><img v-if="CompanyInfo" style=" max-height: 50px;cursor:pointer;" :src="(Urlpath=='/'?'':Urlpath)+CompanyInfo.Logo" @click="toOurWeb()"> </span>


                  </div>

                  <div class="right-menu" style="margin-right:25px;position:relative;text-align:right;display:flex;justify-content: flex-end;">
                    
                        
                    
                  
                  
                    <div class="news-list" v-show="showNoticeData" :class="UserContext.UserType==1?'news-list2' :'news-list3'">
                      <ul>
                        <li style="padding: 5px 0px;border-bottom: 1px solid rgba(120, 130, 140, 0.13);cursor:pointer;" v-for="o in SearchSys_New" :key="o.ID">
                          <div style="display:flex;align-items:center;"  @click="ToNew(o.ID)">
                            <i class="el-icon-news" style="font-size:27px;margin:0px 20px;color: rgb(56, 121, 237);"></i>
                            <div style="text-align:left;">
                              <div style="line-height:25px;">{{o.Title}}</div>
                              <div style="line-height:20px;font-size:12px;color:#67757c;">{{o.OperatorTime}}</div>
                            </div>
                          </div>
                        </li>

                      </ul>
                    </div>
                    
                    
                      <span v-if="Me && Me.Account" style="font-size: 13px;    line-height: 50px;">{{gets('$余额')}}:{{Me.Account.realBalance+ '('+ (Me.Account.Currency.EnName)+ ')'}}</span>
                   
                   <span style="display:inline-block;width:60px; text-align:center; text-color:#666; font-size:14px;">{{gets('$待办')}}</span>
                  </div>
                
                </el-menu> -->
            </div>
          </div>
        </div>
      </div>


      <!--窗口列表-->
      <div class="tags-view-container" :style="{'width':Iscollapse?'96% !important':'85% !important','z-index':'4','position': 'fixed', 'top': '70px', 'overflow': 'hidden', }" >

        <scroll-pane class='tags-view-wrapper acrossTab' ref='scrollPane'>
          
            <a   ref='tag' class="tags-view-item"  :class="d.thisNav.url=='/Root'?'active':''"
                @click='toNav({ "name": "首页", "tag": "Root", "url": "/Root", "moduleID": -10000000 })'
            >
              {{gets("$首页")}}
              
            </a>
        <template  v-for=" i in d.openNavs">
           
          <a  v-show="i.name!='首页'&&i.name!='Home '"  ref='tag' class="tags-view-item"  :class="i==d.thisNav?'active':''"
              @click='toNav(i)'
          >
            {{i.name}}
            <span class='el-icon-close' v-show="i.name!='首页'&&i.name!='Home '" @click.stop='closeNav(i)'></span>
          </a>
         
        </template>
        </scroll-pane>

      

      </div>

      <!--窗口列表-->
      <!-- min-height: 100%; -->
      <section class="app-main" style="z-index:998;background-color:rgb(243, 247, 249);margin: 30px 30px;margin-top:92px;padding-bottom:50px;">
            <div class="frame_right" id="frame_right"   >
              
                <router-view  v-for="i in openWindows" :name="i.tag" v-bind:class="{ Hide: i != thisWindow || i.IsShow}" class="fadeInOut_" :tag="i.tag" ></router-view>
            </div>
      </section>

    </div>
    </div>
    

  </div>








</template>


<style>

   #footer {
                height: 30px;
                line-height: 30px;
                position: fixed;
                bottom: 0;
                width: 100%;
                text-align: center;
                margin-top: 5px;
                color: #fff;
                font-family: Arial;
                font-size: 12px;
                letter-spacing: 1px;
            }
    #getNoticeDialog .GOPURclass{
        margin-left: 10px;
      }
   
      @media screen and (max-width: 1700px){

       #getNoticeDialog .el-dialog{
        width:37% !important;
      }
      /* #getNoticeDialog .GOPURclass{
        margin-left: 104px;
      } */
    }
   @media screen and (max-width: 1400px){
 
       #getNoticeDialog .el-dialog{
        width:56% !important;
      }
    }
    
    @media screen and (max-width: 1370px){
 
       #getNoticeDialog .el-dialog{
        width:45% !important;
      }
    }
     @media screen and (max-width: 1200px){
 
       #getNoticeDialog .el-dialog{
        width:60% !important;
      }
    }
</style>
<script>
  import ScrollPane from '@/components/ScrollPane'
  import gets from '@/model/language.js'
  import bus from "@/model/bus";
  import {
    IsRights,
    Modulel,
    Permission,
    Clone
  } from '@/config/config'
  var isHide = false;
  var self
  import {
    CompanyInfoRequest
  } from '@/request/CompanyInfo'

  import { userRequest } from '@/request/user'
 import {
        Sys_NewRequest
    } from '@/request/Sys_New'

  function blr(p, pPath) {
    for (var i of p) {
      i.allPath = i.path;
      if (pPath) {
        i.allPath = pPath + "/" + i.path
      }
      var myReg = /\/:([\w\d]+)/;
      i.rex = "^" + i.allPath.replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)")
        .replace(myReg, "/([\\w\\d]+)") +
        "$";
      self.routes.push(i)
      if (i.children && i.children.length>0) {
        blr(i.children, i.allPath)
      }
    }
  }
  export default {
    name: 'frame_left',
    components: {
      ScrollPane
    },
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        openWindows: [],
        thisWindow: null,
        routes: [],
        Index: 1,
        window: window,
        IsNotice:false,
        Iscollapse: false,
        CompanyInfo: null,
        $Urlpath: window._$Urlpath,
        Urlpath: window._$Urlpath,
        Me: null,
        PurNotice:0,
        OrderNotice:0,
        SearchSys_New:[],//新闻公告列表
        showNoticeData:false,//新闻公告框
        NameFirst:"",
      }
    },

    created() {
      window.rootVue = this;
      var y$set = window.rootVue.$set;
      window.rootVue.$set = function(ydata,f,data){
          if(window.IsNotRootSet){
              return;
          }
          y$set(ydata,f,data)
      }





      this.$router.push2 = this.$router.push

      self = this;
      var components;
      CompanyInfoRequest.GetCompanyInfo(function(d) {
        if (!d.Message) {
          self.$set(self.$data, 'CompanyInfo', d)
        }
      }, 0)

      userRequest.GetMyUser(function(d) {
        if (!d.Message) {
          self.$set(self.$data, 'Me', d)
        }
      })

      console.log(self.$router.currentRoute.fullPath.toLowerCase())
      if (self.$router.currentRoute.fullPath.toLowerCase() != "/main/index") {
        return;
      }else{
         
      }
      for (var i of self.$router.currentRoute.matched) {
        if (i.path == '/Main/index') {
          components = i.components = {};
        }
      }
      for (var i of self.$router.options.routes) {
        if (i.name == 'Main') {
          for (var c of i.children) {
            if (c.path != "index") {
              components[c.path] = c.component;
            }
          }
        }
      }
      blr(self.$router.options.routes)

      this.$router.push = function(data) { //覆盖掉router的方法
        var path = "";
        var params = {};
        if (typeof data === 'string') {
          if (data.toLowerCase() == "/main/index") {
            self.openWindows.splice(0, self.openWindows.length)
            self.d.openNavs.splice(0, self.d.openNavs.length)
          }
          path = data;
        } else {
          path = data.path;
          console.log(path,22222)
        }

        //   try {
        //  gtag('config', 'UA-145397447-1', {'pageview': path});
        //  gtag('set', 'page', path.replace('#',''));
        //  gtag('send', 'pageview');

        //   } catch (error) {

        //   }

        for (var c of self.routes) {
          var re = new RegExp(c.rex)
          if (re.exec(path)) {
            var ds = c.allPath.split('/:')
            ds.splice(0, 1)
            var index = 1;
            for (var f of ds) {
              params[f] = RegExp['$' + index]
              index++;
            }
            var tag = self.d.thisNav.tag + "&" + path + "&" + self.getIndex();
            for (var i in params) {
              self.$route.params[i] = params[i];
            }
            components[tag] = c.component;
            var d = {
              tag: tag,
              params: params
            }
            self.openWindows.push(d)
            self.$set(self.$data, 'thisWindow', d)
          }
        }
      
      }
      this.$router.replace = function(data) { //覆盖掉router的方法
        var d = self.thisWindow;
        self.$router.push(data)
        var index = 0;
        for (var i of self.openWindows) {
          if (i === d) {
            self.openWindows.splice(index, 1)
          }
          index++;
        }
      }
      this.$router.go = function(index) { //覆盖掉router的方法
        if (index >= 0) {
          return;
        }
        var neb = Math.abs(index);
        var c = 0;
        for (var i = self.openWindows.length - 1; i >= 0; i--) {
          if (self.openWindows[i].tag.split('&')[0] == self.d.thisNav.tag) {
            c++;
            if (self.openWindows[i].tag.split('&').length == 1) {
              return
            }
            self.openWindows.splice(i, 1);
            self.setLastWindowByNav(self.d.thisNav.tag)
            var v = self.getThisWindowVueComponent();
            if (v && v.OnBack) {
              v.OnBack()
            }
            if (c == neb) {
              return
            }
          }
        }
      }




         userRequest.GetUserRights(function(d) {
            self.$set(self.$store.state.UserRights, 'UserContext',  d.UserContext)
            self.NameFirst =  d.UserContext.LastName.substr(0, 1)
            self.$set(self.$store.state.UserRights, 'Rights',  d.Rights)

            if (self.$router.currentRoute.fullPath.toLowerCase() != "/main/index") {
            }else{
              self.openNav(self.$store.state.Navs.navs[0],self.$store.state.Navs.navs[0].twoNavs[0])
            }

        }, {})



    //     if(true)
    //     {
    //     this.$alert('<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
    //       dangerouslyUseHTMLString: true
    //     });
    // }
    this.init()
     
    },
    computed: {
      d() {
        window.rootVue = this;
        if (this.UserContext && this.UserContext.UserType != 0) {
          return this.$store.state.CustomerNavs
        }
        return this.$store.state.Navs
      },
      UserContext() {
        return window.rootVue.$store.state.UserRights.UserContext;
      },
       language() {
        return window.$.cookie('LanguagesTag')
      },
    },
    mounted() {
          //   this.opennotice();
          //     // this.timer = setInterval(() => {
          //     //     this.opennotice
          //     // },600000)
          //  setInterval(this.opennotice, 600000);
          
         
    },
    // beforeDestroy() {
    //     //清除定时器
    //     clearInterval(this.timer);
    //     console.log("beforeDestroy");
    // },
    methods: {
      toMall(){
         window.rootVue.openNav(self.$store.state.routerNavs.navs[0],self.$store.state.routerNavs.navs[1].twoNavs[5]);
      },
      
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      isC(){
		      this.Iscollapse = !this.Iscollapse
		  },
      toMyQusetion(){
         self.openNav(self.$store.state.routerNavs.navs[0],self.$store.state.routerNavs.navs[1].twoNavs[4]);
      },
      openDashboard(){
        //self.$router.push('/Root')
        self.openNav(self.$store.state.Navs.navs[0],self.$store.state.Navs.navs[0].twoNavs[0]);

      },

      showNotice(ev){
        if (this.showNoticeData==false) {
          this.showNoticeData=true
          // 阻止事件冒泡
          var oEvent = ev || event;
          oEvent.cancelBubble = true;
        }else{
          
          this.showNoticeData=false
        }
        
      },
      closeNotice(item){
        this.showNoticeData=false
       
      },
         init() {               
                var self = this;
                self.toSearchSys_New();
                //新闻公告点击其他区域关闭             
                $("body").on("click",function(){
                  self.showNoticeData = false                 
                });     
                    
            },
       toSearchSys_New() {
                var self = this;
                Sys_NewRequest.SearchSys_New(function(d) {
                    self.$set(self.$data, ("SearchSys_New"), d.Records)
                    // if(self.SearchSys_New.length>4){
                    //     self.SearchSys_New = self.SearchSys_New.splice(0,4)
                    // }
                }, {PageSize:6,Status:1,SeeTypeArr: self.UserContext.UserType==0?[0,2] :[0,1]})
            },
             ToNew(ID){
                window.open("#/New/"+ID)
            },
 
GOPUR()
{
  this.IsNotice=false;


if(self.UserContext.UserType != 0)
{
self.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[0].twoNavs[3]);
}

else{

self.openNav(self.$store.state.Navs.navs[1],self.$store.state.Navs.navs[5].twoNavs[1])};
}
,

GONotice()
{
  this.IsNotice=false;
  if(self.UserContext.UserType != 0)
{
 
self.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[2].twoNavs[1]);
}
else{
  
self.openNav(self.$store.state.Navs.navs[1],self.$store.state.Navs.navs[5].twoNavs[3])
}
}
,
     opennotice()
     {

       userRequest.GetNotice(function(d) {
        if (d.Message=="OK") {
       self.OrderNotice=d.OrderNumber;
       self.PurNotice=d.PurnNumber;
      // self.OrderNotice=5;
      //  self.PurNotice=5;
       if(self.OrderNotice>0||self.PurNotice>0)
       {


if(self.UserContext.UserType ==0)
{
  if(IsRights(Modulel.QuestionManage, Permission.See)||IsRights(Modulel.PurchaseRequestManage, Permission.See))
  self.IsNotice=true;
else
self.IsNotice=false;
}
else
self.IsNotice=true;
       }
       else
       {
         self.IsNotice=false;
       }

                 }
      })


     }


      ,


      UserCommand(command) {
        if (command == "Exit") {
          window.location.href = window.location.href.split('#')[0]
        }
  if (command == "User") {
    //self.$router.push('/PersonalInformation')
           
      //self.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[0].twoNavs[3]);
self.openNav(self.$store.state.routerNavs.navs[0],self.$store.state.routerNavs.navs[0].twoNavs[0]);
  }




      },









      IsRight(modelID) {
        
        if(modelID===6016 && self.UserContext.ID===1520){
          console.log('2386 运费不可见')
          return false
        }
        if (self.UserContext && self.UserContext.UserType != 0) {
          return true
        }
        return IsRights(modelID, Permission.See)
      },
      IsShowNavs(navs){
         if (self.UserContext && self.UserContext.UserType != 0) {
          return true
        }
         var boo =false;
          for(var i of navs){
              if(this.IsRight(i.moduleID)){
                return true;
              }
          }
          return boo;
      },
      getIndex() {
        this.Index++;
        return this.Index;
      },
      gets: gets,
      getLastWindowByNav(NavTag) {
    
        for (var i = this.openWindows.length - 1; i >= 0; i--) {
          if (this.openWindows[i].tag.split('&')[0] == NavTag) {
            return this.openWindows[i];
          }
        }
      },
      setLastWindowByNav(NavTag) {
        if (self.$route.params && self.thisWindow && self.thisWindow.params) {
          for (var hh in self.$route.params) {
            self.thisWindow.params[hh] = self.$route.params[hh];
          }
        }
        if (!self.getLastWindowByNav(NavTag)) {
          return;
        }
        self.$set(self.$data, 'thisWindow', self.getLastWindowByNav(NavTag))
        if (self.getLastWindowByNav(NavTag).params) {
          for (var hh in self.getLastWindowByNav(NavTag).params) {
            self.$route.params[hh] = self.getLastWindowByNav(NavTag).params[hh];
          }
        }
      },
      openNav(i, c) {
        window.rootVue = this;
        var is = this.d.openNavs.find((e) => e.url == c.url);
        if (!is) {
          this.$set(this.d, 'thisNav', c)
          this.d.openNavs.push(c)
          //this.openWindows.push(c)
          self.setLastWindowByNav(c.tag)
          this.$set(this.d, 'openNavs', this.d.openNavs)
          this.$router.push(c.url)
          console.log(c.url,45465456)
          if(c.url=='/AddMallPurchase/0'){
            localStorage.setItem("isNavAddMallPurchase",1)
          }
        } else {
            self.closeNav(c)

            // console.log(i,c,"openNav")
            // i.map((item)=>{
            //   if(item.url = c.url){
            //       self.openNav(i, c)
            //   }
            // })
            window.setTimeout(function(){
             
            self.openNav(i, c)
            
             
            },100)
        }
        this.$set(i, 'isShow', false)
      },
      li_mousemove(i) {
        window.rootVue = this;
        i.isHide = false
        if (!i.isShow) {
          this.$set(i, 'isShow', true)
        }
      },
      li_mouseout(i) {
        window.rootVue = this;
      
        var gos = this;
        i.isHide = true;
        setTimeout(function() {
          if (i.isHide) {
            gos.$set(i, 'isShow', false)
          }
        }, 250)
      },
      toNav(i) {
        if (i) {
          self.setLastWindowByNav(i.tag)
          this.$set(this.d, 'thisNav', i)
        }
        //this.$router.push(i.url)
      },
      closeNav(c) {
        
        var v = 0
        var df = 0;
        for (var i of this.d.openNavs) {
          if (i == c) {
            if (this.d.thisNav == c) {
              if (v - 1 >= 0) {
                df = v - 1;
              } else {
                // this.$router.push("/Main/index")
              }
            }
            for (var index = 0; index < this.openWindows.length; index++) {
              var g = this.openWindows[index];
              if (g.tag.split('&')[0] == c.tag) {
                this.openWindows.splice(index, 1);
                index--;
              }
            }
            this.d.openNavs.splice(v, 1);
          }
          v++;
        }
        console.log(c,this.d)
        if(c.url==this.d.thisNav.url){
          self.toNav(this.d.openNavs[this.d.openNavs.length-1])
        }
        //s
       
        //self.toNav(this.d.openNavs[df])
      },
      setThisWindowVueComponent(Component) { //设置当前窗口的 VueComponent
        if (self.thisWindow) {
          self.thisWindow.vue = Component;
        }
      },
      getThisWindowVueComponent() { //获取当前窗口的 VueComponent
        if (self.thisWindow) {
          return self.thisWindow.vue;
        }
        return null
      },
      getThisWindow() { //获取当前窗口的 thisWindow
        return self.thisWindow
      },

      getWindowsByTag(Tag) { //获取窗口的 所有符合 正则Tag 的VueComponent
        if (self.thisWindow) {
          return self.thisWindow.vue;
        }
        var arr = [];
        for (var i of self.openWindows) {
          var re = new RegExp(Tag)
          if (re.exec(i.tag)) {
            arr.push(i)
          }
        }
        return arr
      },
      getThisTagWindowList() {
        var arr = [];
        for (var i = self.openWindows.length - 1; i >= 0; i--) {
          if (self.openWindows[i].tag.split('&')[0] == self.d.thisNav.tag) {
            arr.push(self.openWindows[i])
          }
        }
        return arr;
      },

      IsWindowByTag(Tag) { //查询改tag是否当前窗口的

          
          return window.rootVue.thisWindow.tag.indexOf(Tag+"&")==0;
      }

    },
    watch: {
      thisWindow() {
        setTimeout(function() {
          window.$('html').animate({
            scrollTop: 0
          }, 0)
        }, 500)
      }
    },

  }
</script>

<!-- @import '../assets/bootstrap/css/bootstrap.min.css'; -->
<style lang='css'>
.serviceImg{
  width: 75%;
  position: relative;
}
.servicePositionText{
  position: absolute;
  font-size: 25px;
  right: 35%;
  bottom: 20%;
  font-weight: bold;
}
.indexScroll .el-scrollbar__wrap{
  height: 85%;
}
.addSidebar{
  cursor: pointer;
}
.addSidebar:hover,.addSidebar:active{
  background-color: #093578;
}
.navAddText{
  color: #fff !important;
              /* background-color: #062A63 !important; */
              font-size: 19px !important;
              font-weight: bold;
              font-family: Helvetica;
}
.sidebar-container .CustomSidebar:hover{
  background-color: #093578 !important;
}
.sidebar-container .CustomSidebar:active{
  background-color: #093578 !important;
}
.sidebar-container .CustomSidebar2:hover{
  background-color: #4a4b4e !important;
}
.sidebar-container .CustomSidebar2:active{
  background-color: #4a4b4e !important;
}
.horizontalMenu
  .main-container .el-icon-s-unfold{
    color: #093578;
    font-size: 25px;
    font-weight: bold;
    margin-left: 30px;
    margin-top: 16px;
  }
  .userBG{
    width: 40px;
    height: 40px;
    background-color: #716FEE;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    margin-left: 40px;
    margin-right: 30px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
  #app .sidebar-container .el-menu {
    height: 100% !important;
    background:#062A63 !important;
  }
#app .sidebar-container2 .el-menu{
  height: 100% !important;
  background:#100A09 !important;
}
#app .sidebar-container .el-dropdown-menu__item--divided:before, .el-menu, .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus{
  background:#062A63 !important;
}
#app .sidebar-container2 .el-dropdown-menu__item--divided:before, .el-menu, .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus{
  background:#100A09 !important;
}
  #app .sidebar-container{
    width: 65% !important;
    background-color: #062A63;
  }
   #app .sidebar-container2{
    width: 65% !important;
    background-color: #100A09;
  }
  .customerHorizontalMenu{
    position: relative;
  }
  .customerHorizontalMenu .el-menu-item.is-active{
    background-color: #093578 !important;
  }
  .horizontalMenu {
    background-color: #4a4b4e !important;
  }
  .customerHorizontalMenu .el-submenu__title{
    color: #fff !important;
    background-color: #062A63 !important;
    font-size: 18px !important;
    font-weight: bold;
    font-family: Helvetica;
  }
   .horizontalMenu .el-submenu__title{
     font-size: 18px !important;
     font-weight: 600;
      color: #fff !important;
     background-color: #100A09 !important;
   }
  .el-submenu{
    margin:7px 0px !important;
  }
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title .el-icon-coin{
  /* font-size: 17px !important; */
  
}

.el-icon-coin{
  font-size: 17px !important;
}
  .el-menu--popup-bottom-start{
    background-color: transparent !important;
  }
  .horizontalMenu  .el-menu--popup-bottom-start{
    background-color: rgb(34, 34, 34)!important;
  } 
  /* .el-menu--horizontal{
     background-color: #2B3C58 !important;
  } */
  /* .el-menu{
     background:transparent !important;
  } */
  .el-submenu i{
    font-size: 19px !important;
    color: #fff !important;
    margin-right: 10px !important;
  }
  /* .el-submenu__title i{
    color: #fff !important;
  } */
  /* .el-scrollbar__wrap{
    overflow: hidden !important;
  } */
  .el-scrollbar .el-scrollbar__wrap{
    margin-right: -25px !important;
  }
  /* .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
    color: #fff;
  } */
  @import '../assets/css/css.css';
  @import '../assets/zTree/css/zTreeStyle/zTreeStyle.css';
  #frame_window ul li a {
    color: #fff
  }
  .Hide {
    display: none;
  }
  .el-scrollbar {
    height: 100%;
    background: transparent;
  }
  html {
    background-color: #fff;
    color: #666;
  }
  .navbar,
  .el-dropdown-link {
    color: #000 !important;
    font-family: Helvetica Neue;
    font-size: 17px;
  }
  .el-scrollbar__view {
    border-right: 1px solid #e5e5e5;
  }
 .el-menu-item:focus, .el-menu-item:hover{
   background-color: #093578 !important;
 }
 .sidebar-container .CustomSidebar2:hover{
  background-color: #4a4b4e !important;
}
.sidebar-container2 .el-menu-item:focus, .el-menu-item:hover{
  background-color: #4a4b4e !important;
}
 .el-menu--popup .el-menu-item{
   color: #fff !important;
 }
 .el-menu--popup .el-menu-item:hover ,.el-menu--popup .el-menu-item:focus{
   background-color: #093578 !important;
 }
  .el-dropdown-menu__item--divided:before, .el-menu, .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus{

    background-color: #062A63 !important;

  }
 .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
	background-color: #093578 !important;
}
.el-tooltip__popper{
  z-index: 2000 !important;
}
 /* .el-menu-item:focus */
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/assets/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #F3F7F9;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
    .breadcrumb-container {
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right;
      height: 100%;
      width: 100%;
      &:focus {
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international {
        vertical-align: top;
        cursor: pointer;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 50px;
        margin-right: 30px;
        .avatar-wrapper {
          cursor: pointer;
          margin-top: 5px;
          position: relative;
          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .tags-view-container {
    background-color: #F3F7F9;
    padding: 0 30px 5px 30px;
    
    .tags-view-wrapper {
      box-shadow: 0 0 10px 5px #dcdfe626;
      background: #fff;
      margin-top: 30px;
      height: 37px;
      border-radius: 5px;
      .tags-view-item {
        display: inline-block;
        position: relative;
        height: 38px;
        line-height: 38px;
        color: #303133;
        font-weight: 600;
        margin: 0 15px;
        font-size: 15px;
        padding: 0px 10px;
        &:first-of-type {
          margin-left: 30px;
        }
        &.active {
          border-bottom: 5px solid #3C87F7;
          background-color: #fff;
          color: #3C87F7;
          margin-right: 30px;
          &::before {
            content: '';
            background: #fff;
            display: inline-block;
            // width: 8px;
            // height: 8px;
            border-radius: 50%;
            position: relative;
            
          }
        }
      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
  @-webkit-keyframes fadenum{
0%{opacity: 0;}
100%{opacity: 1;}
}
@-moz-keyframes fadenum{
0%{opacity: 0;}
100%{opacity: 1;}
}
@-o-keyframes fadenum{
0%{opacity: 0;}
100%{opacity: 1;}
}
@keyframes fadenum{
0%{opacity: 0;}
// 25%  {opacity: 1;left:-30px;}
// 50%  {opacity: 1;left:-60px;}
// 75%  {opacity: 1;left:-90px;}
100%{opacity: 1; }
}
  .news-list{
    color:#333;
    font-size:15px;
    width:300px;    
    background: #FFFFFF;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
    position:absolute; 
    
    //right: 0px;
    z-index: 50;
    height: 250px;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-animation: fadenum 1.5s ease; 
    -moz-animation: fadenum 1.5s ease;
    animation:fadenum 1.5s ease;
  }
  .news-list2{
    left: -30px;
    top:70px;
  }
  .news-list3{
    left: -17%;
    top:70px;
  }
  .news-list::-webkit-scrollbar{
    width:5px;
    height:10px;
  }
  .notify{
    position: relative;
    top: -16px;
    right: -8px;
  }
.notify .heartbit {
    position: absolute;
    top: -20px;
    right: -4px;
    height: 25px;
    width: 25px;
    z-index: 10;
    border: 5px solid #0DCB07;
    border-radius: 70px;
    -moz-animation: heartbit 1s ease-out;
    -moz-animation-iteration-count: infinite;
    -o-animation: heartbit 1s ease-out;
    -o-animation-iteration-count: infinite;
    -webkit-animation: heartbit 1s ease-out;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-box-direction: normal;
    -webkit-tap-highlight-color: transparent;
}
@keyframes heartbit {
  
  0% {
    -webkit-transform: scale(0);
    opacity: 0.0;
}
25% {
    -webkit-transform: scale(0.1);
    opacity: 0.1;
}
50% {
    -webkit-transform: scale(0.5);
    opacity: 0.3;
}
75% {
    -webkit-transform: scale(0.8);
    opacity: 0.5;
}
100% {
    -webkit-transform: scale(1);
    opacity: 0.0;
}
}

// span.heartbit {
// }
.notify .point {
    width: 6px;
    height: 6px;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    background-color: #0DCB07;
    position: absolute;
    right: 6px;
    top: -10px;
}
 	
  #app .sidebar-container2 .nest-menu .el-submenu > .el-submenu__title,
#app .sidebar-container2 .el-submenu .el-menu-item {
	min-width: 180px !important;
	background-color: #100A09 !important;
	color: #fff !important;
}
	#app .sidebar-container2 .nest-menu .el-submenu > .el-submenu__title:hover,
	#app .sidebar-container2 .el-submenu .el-menu-item:hover {
		background-color: #4a4b4e !important;
		color: #fff !important;
	}
#app .sidebar-container2 .el-submenu .is-active{
      border-left: 3px solid #E88300;
  background-color: #4a4b4e !important;
}
</style>


<style rel="stylesheet/scss" lang="scss">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        
        border-radius: 50%;
        text-align: center;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;
        &:before {
          transform: scale(.6);
          display: inline-block;
          
        }
        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// main.vue?e3288350